import { handleAction, combineActions } from 'redux-actions';

import { authAction, loginAction, logoutAction, userAction } from '../actions/authentication';
import { getDatasourceStatesAction } from '../actions/dataSources';
import { defaultErrorHandler, isError } from './errors';

const initialState = {};

export const sessionReducer = (state, action) => {
  if (action.type === logoutAction.toString()) {
    // Reset user state
    return initialState;
  }
  if (isError(action)) {
    return state;
  }
  if (action.type === getDatasourceStatesAction.toString()) {
    return {
      ...state,
      user: {
        ...state.user,
        services: (action.payload || []).map(service => ({ name: service.service })),
      }
    }
  }
  return action.payload;
};

export default handleAction(combineActions(
    authAction,
    getDatasourceStatesAction,
    loginAction,
    logoutAction,
    userAction,
  ), {
  next: sessionReducer,
  throw: defaultErrorHandler,
}, initialState);
